export const EDIT_SERVED_ITEM_FETCHING = 'EDIT_SERVED_ITEM_FETCHING';
export const EDIT_SERVED_ITEM_FETCH_ERROR = 'EDIT_SERVED_ITEM_FETCH_ERROR';
export const EDIT_SERVED_ITEM_GET_DATA = 'EDIT_SERVED_ITEM_GET_ITEM_DATA';
export const EDIT_SERVED_ITEM_GET_NUTRITION_CODES =
  'EDIT_SERVED_ITEM_GET_NUTRITION_CODES';
export const EDIT_SERVED_ITEM_GET_ITEM_CATEGORIES =
  'EDIT_SERVED_ITEM_GET_ITEM_CATEGORIES';
export const EDIT_SERVED_ITEM_GET_ALTERNATE_ITEMS =
  'EDIT_SERVED_ITEM_GET_ALTERNATE_ITEMS';
export const EDIT_SERVED_ITEM_GET_GRADES = 'EDIT_SERVED_ITEM_GET_GRADES';
export const EDIT_SERVED_ITEM_CLEAR_STATE = 'EDIT_SERVED_ITEM_CLEAR_STATE';
export const EDIT_SERVED_ITEM_NEW_ID = 'EDIT_SERVED_ITEM_NEW_ID';



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/editserveditem/types.js